import {Directive, TemplateRef, input} from '@angular/core';
import { CommandButtonComponent } from './commandbutton/commandbutton.component';
import { Claims } from '../../types';

@Directive({
    selector: '[commandbar-right]',
    standalone: true
})

export class CommandBarRightDirective {
  hasClaim: boolean;

  readonly requiresClaim = input<Claims>(null);
  constructor(public template: TemplateRef<CommandButtonComponent>) {}
}
